import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { axios } from '../../context/AuthContext';

const PAGE_TITLES = {
  '/admin/dashboard': 'Dashboard',
  '/admin/ogrenciler': 'Öğrenciler',
  '/admin/ogretmenler': 'Öğretmenler',
  '/admin/veliler': 'Veliler',
  '/admin/siniflar': 'Sınıflar',
  '/admin/denemeler': 'Denemeler & Analiz',
  '/admin/ogrenci-deneme-analiz': 'Öğrenci Deneme Teknik Analiz',
  '/admin/turkiye-geneli-deneme-sonuclari': 'Türkiye Geneli Deneme Sonuçları',
  '/admin/ders-programi': 'Ders Programı',
  '/admin/devamsizlik': 'Yoklama Al / Düzenle',
  '/admin/sistem-analiz': 'Sistem Analizi',
  '/admin/bildirimler': 'Bildirimler',
  '/admin/toplu-mesaj': 'Toplu Mesaj',
  '/admin/kullanicilar': 'Kullanıcılar',
  '/ogretmen/dashboard': 'Dashboard',
  '/ogretmen/yoklama': 'Yoklama',
  '/ogretmen/odevler': 'Ödevler',
  '/ogretmen/program': 'Ders Programım',
  '/ogretmen/denemeler': 'Denemeler',
  '/ogretmen/ogrenci-deneme-analiz': 'Öğrenci Deneme Teknik Analiz',
  '/ogretmen/randevular': 'Randevular',
  '/rehber/dashboard': 'Dashboard',
  '/rehber/ogrenciler': 'Öğrenciler',
  '/rehber/ogretmenler': 'Öğretmenler',
  '/rehber/veliler': 'Veliler',
  '/rehber/siniflar': 'Sınıflar',
  '/rehber/denemeler': 'Denemeler & Analiz',
  '/rehber/ogrenci-deneme-analiz': 'Öğrenci Deneme Teknik Analiz',
  '/rehber/turkiye-geneli-deneme-sonuclari': 'Türkiye Geneli Deneme Sonuçları',
  '/rehber/devamsizlik': 'Yoklama Al / Düzenle',
  '/rehber/gorusmeler': 'Görüşmeler',
  '/rehber/seans-olustur': 'Öğrenci Seansı Oluştur',
  '/rehber/konular': 'Konular',
  '/rehber/tekrarlar': 'Tekrarlar',
  '/rehber/programlar': 'Çalışma Programları',
  '/rehber/etutler': 'Etüt Talepleri',
  '/rehber/randevular': 'Randevular',
  '/rehber/toplu-mesaj': 'Toplu Mesaj',
  '/rehber/gonderilen-mesajlar': 'Gönderilen Mesajlar',
  '/muhasebe/ogrenciler': 'Öğrenciler',
  '/muhasebe/ogretmenler': 'Öğretmenler',
  '/muhasebe/veliler': 'Veliler',
  '/muhasebe/siniflar': 'Sınıflar',
  '/veli/dashboard': 'Dashboard',
  '/veli/basari': 'Başarı Takibi',
  '/veli/devamsizlik': 'Devamsızlık',
  '/veli/bildirimler': 'Bildirimler',
  '/ogrenci/dashboard': 'Dashboard',
  '/ogrenci/odevler': 'Ödevlerim',
  '/ogrenci/yoklama': 'Yoklamaya Katıl',
  '/ogrenci/program': 'Ders Programım',
  '/ogrenci/siralama': 'Sıralama',
  '/ogrenci/randevu': 'Randevu Oluştur',
  '/ogrenci/etut': 'Etüt Talebi',
  '/ogrenci/bildirimler': 'Bildirimler',
  '/ayarlar': 'Ayarlar',
};

export default function Topbar({ collapsed, onToggle }) {
  const { user, unreadCount } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [showNotifs, setShowNotifs] = useState(false);
  const [notifs, setNotifs] = useState([]);
  const notifRef = useRef(null);

  const title = PAGE_TITLES[location.pathname] || 'Dershane Pro';
  const segment = location.pathname.split('/')[1];
  const sectionMap = { admin: 'Yönetim', ogretmen: 'Öğretmen', rehber: 'Rehberlik', muhasebe: 'Muhasebe', veli: 'Veli', ogrenci: 'Öğrenci' };
  const section = sectionMap[segment] || '';

  useEffect(() => {
    const handler = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target)) {
        setShowNotifs(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const loadNotifs = async () => {
    try {
      const { data } = await axios.get('/bildirimler?limit=8');
      if (data.success) setNotifs(data.data);
    } catch (e) {}
  };

  const handleNotifToggle = () => {
    if (!showNotifs) loadNotifs();
    setShowNotifs(v => !v);
  };

  const markRead = async (id) => {
    try {
      await axios.put(`/bildirimler/${id}/oku`);
      setNotifs(prev => prev.map(n => n.id === id ? { ...n, okundu: 1 } : n));
    } catch (e) {}
  };

  const initials = user ? `${user.ad?.[0] || ''}${user.soyad?.[0] || ''}`.toUpperCase() : '?';

  return (
    <header className={`topbar ${collapsed ? 'collapsed' : ''}`}>
      {/* Collapse toggle */}
      <button
        className="btn btn-ghost btn-icon"
        onClick={onToggle}
        style={{ color: 'var(--text-muted)', fontSize: '1.1rem', flexShrink: 0 }}
      >
        {collapsed ? '▶' : '◀'}
      </button>

      {/* Breadcrumb */}
      <div style={{ flex: 1 }}>
        {section && (
          <div className="topbar-breadcrumb">{section} /</div>
        )}
        <div className="topbar-title">{title}</div>
      </div>

      {/* Actions */}
      <div className="topbar-actions">

        {/* Notifications */}
        <div style={{ position: 'relative' }} ref={notifRef}>
          <button
            className="btn btn-ghost btn-icon"
            onClick={handleNotifToggle}
            style={{ position: 'relative', color: 'var(--text-secondary)' }}
          >
            <span style={{ fontSize: '1.1rem' }}>◉</span>
            {unreadCount > 0 && <div className="notif-dot" />}
          </button>

          {showNotifs && (
            <div style={{
              position: 'absolute', top: '110%', right: 0,
              width: 340, background: 'var(--bg-surface)',
              border: '1px solid var(--border-strong)',
              borderRadius: 'var(--r-lg)',
              boxShadow: 'var(--shadow-lg)',
              animation: 'fadeInDown 0.2s ease both',
              zIndex: 300,
              overflow: 'hidden',
            }}>
              <div style={{ padding: '14px 16px', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontFamily: 'var(--font-ui)', fontWeight: 700, fontSize: '1rem' }}>Bildirimler</span>
                {unreadCount > 0 && (
                  <span style={{ fontSize: '0.72rem', background: 'var(--accent-dim)', color: 'var(--accent-light)', padding: '2px 8px', borderRadius: 'var(--r-full)', border: '1px solid var(--accent-border)' }}>
                    {unreadCount} yeni
                  </span>
                )}
              </div>
              <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                {notifs.length === 0 ? (
                  <div style={{ padding: '24px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.875rem' }}>
                    Bildirim yok
                  </div>
                ) : notifs.map(n => (
                  <div
                    key={n.id}
                    onClick={() => markRead(n.id)}
                    style={{
                      padding: '12px 16px',
                      borderBottom: '1px solid var(--border)',
                      cursor: 'pointer',
                      background: n.okundu ? 'transparent' : 'rgba(192,57,43,0.04)',
                      transition: 'background 0.15s',
                      display: 'flex', gap: 10, alignItems: 'flex-start',
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-elevated)'}
                    onMouseLeave={e => e.currentTarget.style.background = n.okundu ? 'transparent' : 'rgba(192,57,43,0.04)'}
                  >
                    {!n.okundu && (
                      <div style={{ width: 6, height: 6, background: 'var(--accent)', borderRadius: '50%', flexShrink: 0, marginTop: 6 }} />
                    )}
                    <div style={{ flex: 1, paddingLeft: n.okundu ? 16 : 0 }}>
                      <div style={{ fontSize: '0.82rem', fontWeight: 600, color: 'var(--text-primary)', marginBottom: 2 }}>{n.baslik}</div>
                      <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', lineHeight: 1.4 }}>{n.mesaj}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ padding: '10px 16px', borderTop: '1px solid var(--border)' }}>
                <button
                  className="btn btn-ghost"
                  style={{ width: '100%', fontSize: '0.8rem', justifyContent: 'center' }}
                  onClick={() => { 
                    setShowNotifs(false); 
                    const bildirimPath = { admin: '/admin/bildirimler', ogretmen: '/ogretmen/bildirimler', rehber: '/rehber/bildirimler', veli: '/veli/bildirimler', ogrenci: '/ogrenci/bildirimler' };
                    navigate(bildirimPath[segment] || '/ayarlar');
                  }}
                >
                  Tümünü Gör →
                </button>
              </div>
            </div>
          )}
        </div>

        {/* User Pill */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: 9,
          padding: '5px 12px 5px 5px',
          background: 'var(--bg-elevated)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--r-full)',
          cursor: 'pointer',
          transition: 'all 0.2s',
        }}
          onClick={() => navigate('/ayarlar')}
          onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--accent-border)'}
          onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border)'}
        >
          <div className="avatar avatar-sm">{initials}</div>
          <div>
            <div style={{ fontSize: '0.8rem', fontWeight: 600, lineHeight: 1 }}>{user?.ad}</div>
            <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)' }}>{user?.rol?.replace('_', ' ')}</div>
          </div>
        </div>
      </div>
    </header>
  );
}
